export default {
	name: "Optimal",
	audio: {},
	connection: "ftp",
	ifcd: true, // require IFCD number on production
	disableArticles: ["total", "part", "ebook"],
	allowMissingISBN: true,
};
